exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-validation-list {\n  list-style: none;\n  padding: 0;\n  padding-bottom: 1.5rem;\n}\n.form-validation-rules {\n  list-style: none;\n  padding: 0;\n  color: #74787f;\n  font-style: italic;\n  font-weight: 600;\n  font-size: .875rem;\n}\n.form-validation-rules li {\n  margin-bottom: .25rem;\n}\n", ""]);

// exports
